












import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import CardRenderer from '@/shared/components/cardRenderer/CardRenderer.vue';
import { Card, CardSubmitEvent, CardSubmitParsedValue } from '@/shared/components/cardRenderer';
import { InstalledApp, AppConfigViewModel } from '@/features/apps/shared/models';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import Toast from '@/shared/services/toast';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import { ConfigRequest } from './configRequest';
import {AppCard} from '@/features/apps/shared/models/appCard';

@Component({
	components: {
		CardRenderer,
		LoadingSpinner
	}
})
export default class CapableAppConfig extends Vue {

	@Getter public currentWorkspace!: WorkspaceViewModel;

	@Prop() public installedApp: InstalledApp;
	@Prop() public configRequest: ConfigRequest;

	public card: AppCard = {
		components: []
	};

	public loading: boolean = true;

	public mounted() {
		this.appConfig(this.installedApp.installedAppId);
	}

	public getCards(): Card[] {
		return [
			{
				id: 'appConfig',
				content: this.card
			}
		];
	}

	public cardSubmit(e: CardSubmitEvent) {
		this.appConfig(this.installedApp.installedAppId, e.parsedValues, e.componentId);
	}

	private async appConfig(installedAppId: string, values?: CardSubmitParsedValue[], componentId?: string) {
		try {
			const res: AppConfigViewModel = await this.configRequest(this.currentWorkspace.id, installedAppId, this.getInputData(values), this.storedData, componentId);
			if (res.card && res.card.components) {
				// more UI to render
				this.card = res.card;
				this.loading = false;
			} else {
				// config endpoint has created a new configuration
				Toast.showSuccess('Configured app');
				this.$emit('configured', installedAppId, res.config);
			}
		} catch (error) {
			Toast.showError(error.message);
			if (!this.card) {
				this.card = {
					components: []
				};
			}
			this.loading = false;
		}
	}

	private getInputData(submittedValues?: CardSubmitParsedValue[]): { [key: string]: string } {
		const values: { [key: string]: string } = {};
		if (submittedValues) {
			for (const value of submittedValues) {
				values[value.id] = value.value;
			}
		}
		return values;
	}

	private get storedData(): { [key: string]: string } {
		if (this.card.storedData) {
			return this.card.storedData;
		}
		return {};
	}
}
